import {Form} from "@/models/gessan/form";
const formState: Form = {
  id: null,
  mesAno: null,
  qtdeUnAbastecimentoAgua: null,
  qtdeUnEsgotamentoSanitario: null,
  faturamentoMensalLiquido: null,
  qtdeUnAbastecimentoAguaDocumento: null,
  qtdeUnEsgotamentoSanitarioDocumento: null,
  faturamentoMensalLiquidoDocumento: null,
  recaptcha: null,
  dataVencimentoDae: null,
  quantidadeLigacoesAtivasAguaCapital: null,
  quantidadeLigacoesAtivasAguaInterior: null,
  quantidadeLigacoesAtivasEsgotoCapital: null,
  quantidadeLigacoesAtivasEsgotoInterior: null,
  faturamentoLiquidoAguaCapital: null,
  faturamentoLiquidoAguaInterior: null,
  faturamentoLiquidoEsgotoCapital: null,
  faturamentoLiquidoEsgotoInterior: null,
  quantidadeLigacoesAtivasAguaCapitalDocumento: null,
  quantidadeLigacoesAtivasAguaInteriorDocumento: null,
  quantidadeLigacoesAtivasEsgotoCapitalDocumento: null,
  quantidadeLigacoesAtivasEsgotoInteriorDocumento: null,
  faturamentoLiquidoAguaCapitalDocumento: null,
  faturamentoLiquidoAguaInteriorDocumento: null,
  faturamentoLiquidoEsgotoCapitalDocumento: null,
  faturamentoLiquidoEsgotoInteriorDocumento: null,
}

export default formState
